import { render, staticRenderFns } from "./ArchiveEditDialog.vue?vue&type=template&id=1fb015b1&"
import script from "./ArchiveEditDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports